import React from "react";
import "./Home.css";
import dpimg2 from "../../images/img -03.jpg";
import { AiOutlineCloudDownload } from "react-icons/ai";
import SocialLinks from "../../components/reusable/SocialLinks";
import WithHelmet from "../../utils/WithHelmet";
// meta tags
const pageTitle = "Md Shahar Shitol | Fullstack developer";
const description =
  "Md Shahar Shitol is a full-stack web developer that enjoys creating web apps and using full-stack web development to make your ideas come to life. Explore our website to discover our projects, blogs, and more.";
const keywords = [
  "web development",
  "full-stack developer",
  "web applications",
  "projects",
  "blogs",
  "md shahar shitol",
  "frontend developer",
  "hire me",
];

const Home = () => {
  return (
    <section
      data-aos="fade-right"
      data-aos-offset="200"
      data-aos-delay="50"
      data-aos-duration="700"
      data-aos-easing="ease-in-out"
      className="w-full h-full pt-8 p-3 background-grid"
    >
      <div className="w-full h-full flex items-center justify-center">
        <div className="card lg:card-side w-full h-full justify-center">
          <figure className="lg:px-10">
            <div className="avatar w-72 flex items-center">
              <div className="h-72 mask mask-squircle annimated-pic">
                <img src={dpimg2} className="img-fluid" width={"200"} alt="" />
              </div>
            </div>
          </figure>
          <div className="flex items-start lg:items-center justify-center mt-3">
            <div className="">
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-5xl lg:text-left text-accent font-bold uppercase text-center">
                Md Shahar Shitol
              </h1>
              <h1 className="text-gray-500 italic font-bold my-6 pr-8 text-center lg:text-left ">
                Bringing your
                <span className=""> ideas to life</span> through
                <span className="text-accent"> Fullstack</span> web development.
              </h1>
              <div className="flex justify-center lg:justify-start">
                <SocialLinks />
              </div>
              <div className="flex justify-center lg:block">
                <a
                  href="https://drive.google.com/file/d/1TbL088tYuIH9TNbwU68foP3Oq9VikIhO/view?usp=share_link"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-outline btn-sm mt-6 hover:px-6 hover:bg-accent hover:text-black hover:border-accent tracking-wide transition-all space-x-2"
                >
                  See Resume
                  <AiOutlineCloudDownload className="ml-1 text-xl" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WithHelmet(Home, pageTitle, description, keywords);
